import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  HStack,
  Switch,
  Pressable,
} from "native-base";

import { Eye, EyeOff } from "lucide-react-native";

import { defaultNavigationProps } from "../../../../Navigator/Navigator";
import { useAPI } from "../../../../Universal/API/API";
import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
import { addToStorage } from "../../../../Universal/API/Storage";
import AdminBlock from "./Components/AdminBlock";
import UserPriceSwitch from "./Components/UserPriceSwitch";
import MainWrapp from "../Components/MainWrapp";

const Account: React.FC<defaultNavigationProps> = ({ navigation, route }) => {
  const { login, getAllData, handleToggleDiscountSwitch } = useAPI();

  const { USER, setUSER, showDiscountedPrices, setShowDiscountedPrices, allUnitData } =
    useAppContext() 

  // --- login form ---
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const redirectTo: string = (route?.params as any)?.redirectTo || "Home";
  const redirectParams: any =
    (route?.params as any)?.redirectParams || undefined;

  const isLoggedIn = Boolean(USER);
  const isAdmin = USER?.role === "admin";

  const handleLoginPress = async () => {
    setError(null);
    setLoading(true);

    try {
      const res = await login({ login: email, password });

      if (!res) {
        setError("Ошибка сервера");
      } else if (!res.success) {
        setError(res.message ?? "Неверный логин или пароль");
      } else {
        // ⚠ важно: чтобы это работало, бэкенд /login должен возвращать role
        // { success, access_token, role, ... }
        
        setTimeout(async () => {
            await getAllData({mode: 'allData'})
        })
        if (redirectParams) {
        //   navigation.reset({
        //     index: 0,
        //     routes: [
        //       { name: redirectTo as never, params: redirectParams as never },
        //     ],
        //   });
        } else {
        //   navigation.reset({
        //     index: 0,
        //     routes: [{ name: redirectTo as never }],
        //   });
        }
      }
    } catch (e) {
      console.error("login error", e);
      setError("Проблема с сетью");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setUSER(null);
    
    addToStorage({ key: "USER_CREDS", data: null });
    addToStorage({ key: "tokens", data: {} });
    setEmail('')
    setPassword('')
    setTimeout(async () => {
            await getAllData({mode: 'allData'})
        })
    // navigation.reset({
    //   index: 0,
    //   routes: [{ name: "Home" as never }],
    // });
  };


  return (
    <MainWrapp>
        <VStack space={8}>
          <Text fontSize="2xl" fontWeight="bold">
            Аккаунт
          </Text>

          {/* ======== LOGIN FORM ======== */}
          {!isLoggedIn && (
            <VStack space={3}>
              <Text fontSize="md" fontWeight="semibold">
                Вход
              </Text>

              <Input
                placeholder="Логин / email"
                value={email}
                onChangeText={setEmail}
                autoCapitalize="none"
              />

              <Input
                placeholder="Пароль"
                value={password}
                onChangeText={setPassword}
                type={showPassword ? "text" : "password"}
                InputRightElement={
                  <Pressable onPress={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <EyeOff
                        size={20}
                        color="#6A6A6A"
                        style={{ marginRight: 12 }}
                      />
                    ) : (
                      <Eye
                        size={20}
                        color="#6A6A6A"
                        style={{ marginRight: 12 }}
                      />
                    )}
                  </Pressable>
                }
              />

              {error && (
                <Text color="red.500" fontSize="sm">
                  {error}
                </Text>
              )}

              <Button
                onPress={handleLoginPress}
                isLoading={loading}
                isDisabled={!email || !password}
              >
                Войти
              </Button>
            </VStack>
          )}

          {/* ======== LOGGED IN BLOCK ======== */}
          {isLoggedIn && (
            <VStack space={8}>
              <VStack>
                <Text fontSize="lg" fontWeight="medium">
                  Вы вошли в аккаунт
                </Text>
                <Text fontSize="sm" color="gray.500">
                  Роль: {USER?.role ?? "—"}
                </Text>
                <Text fontSize="sm" color="gray.500">
                  Скидка: {allUnitData ? `${Object.values(allUnitData)[0]?.discount}%` : 'undefined'}
                </Text>
              </VStack>

              {/* Свич скидок */}
              <VStack space={2}>
                <Text fontSize="md" fontWeight="semibold">
                  Отображение цен
                </Text>

                <HStack alignItems="center" justifyContent="space-between">
                  <VStack flex={1} mr={4}>
                    <Text>Показывать цены со скидкой</Text>
                    <Text fontSize="xs" color="gray.500">
                      Если включено — используется discounted_price.
                    </Text>
                  </VStack>

                  <UserPriceSwitch/>
                </HStack>
              </VStack>

              {/* ======== ADMIN BLOCK ======== */}
              {isAdmin && <AdminBlock />}
              {/* ======== LOGOUT ======== */}
              <Button colorScheme="red" onPress={handleLogout}>
                Выйти
              </Button>
            </VStack>
          )}
        </VStack>
    </MainWrapp>
  );
};

export default Account;
